import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { CheckCircle2, XCircle, Info, AlertTriangle, X } from "lucide-react";
import { cn } from "@/lib/utils";
import type { InlineAlertState } from "@/hooks/useInlineAlert";

interface InlineAlertProps {
  alert: InlineAlertState | null;
  onDismiss?: () => void;
  className?: string;
}

const alertConfig = {
  success: {
    icon: CheckCircle2,
    variant: "success" as const,
  },
  error: {
    icon: XCircle,
    variant: "destructive" as const,
  },
  info: {
    icon: Info,
    variant: "info" as const,
  },
  warning: {
    icon: AlertTriangle,
    variant: "warning" as const,
  },
};

export const InlineAlert = ({ alert, onDismiss, className }: InlineAlertProps) => {
  if (!alert) return null;

  const config = alertConfig[alert.type];
  const Icon = config.icon;

  return (
    <Alert variant={config.variant} className={cn("relative", className)}>
      <Icon className="h-4 w-4" />
      {alert.title && <AlertTitle>{alert.title}</AlertTitle>}
      <AlertDescription>{alert.message}</AlertDescription>
      {onDismiss && (
        <button
          onClick={onDismiss}
          className="absolute right-2 top-2 rounded-md p-1 opacity-70 hover:opacity-100 transition-opacity"
          aria-label="Cerrar"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </Alert>
  );
};
